import { useEffect, useRef, useState } from 'react';
import { useStatus } from '../state/StatusContext';

export function PinnedDropdown() {
  const { snapshot } = useStatus();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  const unresolved = (snapshot?.todos ?? []).filter(t => !t.resolved);

  useEffect(() => {
    if (!open) return;
    function onDoc(ev: MouseEvent) {
      if (wrapRef.current && !wrapRef.current.contains(ev.target as Node)) setOpen(false);
    }
    function onKey(ev: KeyboardEvent) { if (ev.key === 'Escape') setOpen(false); }
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  if (unresolved.length === 0) return null;

  return (
    <div className="pinned-dropdown" ref={wrapRef} data-open={open ? 'true' : 'false'}>
      <button
        type="button"
        className="pd-button"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="pd-title">Pinned</span>
        <span className="pd-count">{unresolved.length}</span>
        <span className="pd-arrow">{open ? '▾' : '▾'}</span>
      </button>
      <div className="pd-panel" role="listbox" aria-label="Pinned items">
        <ul className="pd-list">
          {unresolved.map(t => (
            <li key={String(t.id)} className="pd-row">
              <div className="pd-name">{t.name || '(unnamed)'}</div>
              {t.details ? <div className="pd-details">{t.details}</div> : null}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
